/*
 * @Author: Dom
 * @Date: 2022-05-27 09:13:50
 * @LastEditTime: 2022-08-29 15:43:29
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\account\store.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';
import {
    TableDataType,
    TableListQueryParams,
    AccountInfoParamsType,
    AccountInfoResType,
    DownloadType
} from './data.d';
import {getAccountFlowListByPage, getAccountByUserCode, getAccountBillListByPage, accountBillDownload} from './service'

export interface StateType {
    errorMsg?: string;
    tableData: TableDataType;
    accountinfo: AccountInfoResType;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getAccountInfo: Mutation<StateType>;
        getAccountFlowList: Mutation<StateType>;
    };
    actions: {
        getAccountByUserCodeFn: Action<StateType, StateType>;
        getAccountFlowListByPageFn: Action<StateType, StateType>;
        getAccountBillListByPageFn: Action<StateType, StateType>;
        accountBillDownloadFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    tableData: {
        accountlist: [],
        actbillList: [],
        exhibition: '',
        pagination: {
            total: 0,
            current: 1,
            pageNo: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
        },
    },
    accountinfo: {
        accountMode: 0,
        accountType: 0,
        availableBalance: 0,
        createdAt: '',
        creditQuota: 0,
        currency: 0,
        frozenAmount: 0,
        id: 0,
        updatedAt: '',
        userCode: '',
    },
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'accountquery',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getAccountInfo(state, payload){
            state.accountinfo = payload
        },
        getAccountFlowList(state, payload){
            state.tableData = payload
        },
    },
    actions: {
        //获取用户信息
        async getAccountByUserCodeFn({commit}, params:AccountInfoParamsType){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getAccountByUserCode(params)
                const { body } = req
                const data = body || {}
                commit('getAccountInfo', data)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //获取预付列表信息
        async getAccountFlowListByPageFn({commit}, params:TableListQueryParams){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getAccountFlowListByPage(params)
                const { body } = req
                const countrylistSet = JSON.parse(String(localStorage.getItem('person')))
                body.datas.freightDiscountList.map((s:any) => {
                    countrylistSet.map((item: any) => {
                        if(item.code == s.country){
                            s.country = item.name
                        }
                    })
                })
                commit('getAccountFlowList', {
                    ...initState.tableData,
                    accountlist: body?.datas.freightDiscountList || [],
                    exhibition: body?.datas.exhibition,
                    pagination: {
                        ...initState.tableData.pagination,
                        current: params.pageNo,
                        pageNo: params.pageNo,
                        pageSize: params.pageSize,
                        total: body.sumDataCount || 0
                    }
                })
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },

        //获取账期账单列表信息
        async getAccountBillListByPageFn({commit}, params:TableListQueryParams){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getAccountBillListByPage(params)
                const { body } = req
                commit('getAccountFlowList', {
                    ...initState.tableData,
                    actbillList: body?.datas || [],
                    pagination: {
                        ...initState.tableData.pagination,
                        current: params.pageNo,
                        pageNo: params.pageNo,
                        pageSize: params.pageSize,
                        total: body.sumPageCount || 0
                    }
                })
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        async accountBillDownloadFn({commit}, params:DownloadType){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await accountBillDownload(params)
                const { body } = req
                const data = body || {}
                console.log(data)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel
